export default "__VITE_ASSET__ba17b108__"